import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "site-footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "newsletter" }
const _hoisted_4 = { class: "container footer-main" }
const _hoisted_5 = { class: "footer-grid" }
const _hoisted_6 = { class: "footer-brand-col" }
const _hoisted_7 = { class: "socials" }
const _hoisted_8 = ["href", "aria-label"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "footer-bottom" }
const _hoisted_11 = { class: "container footer-bottom-inner" }

import BrandLogo from "@/components/BrandLogo.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Appfooter',
  setup(__props) {

const year = new Date().getFullYear();

const socials = [
  { label: "Instagram", icon: "bi bi-instagram", url: "#" },
  { label: "Twitter / X", icon: "bi bi-twitter-x", url: "#" },
  { label: "YouTube", icon: "bi bi-youtube", url: "#" },
  { label: "LinkedIn", icon: "bi bi-linkedin", url: "#" },
];

const columns = [
  {
    title: "تمرین",
    links: [
      { text: "داشبورد", to: "/dashboard" },
      { text: "آزمون‌های آزمایشی", to: "/mock-exams" },
      { text: "تمرین ریدینگ", to: "/reading-practice" },
      { text: "تمرین رایتینگ", to: "/writing-exercises" },
      { text: "تمرین شفاهی", to: "/oral-practice" },
    ],
  },
  {
    title: "شرکت",
    links: [
      { text: "درباره ما", url: "#" },
      { text: "سوابق تمرین", to: "/practice-records" },
      { text: "همکاری با ما", url: "#" },
      { text: "وبلاگ", url: "#" },
    ],
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "newsletter-copy" }, [
          _createElementVNode("h3", null, "نکات آیلتس در ایمیل شما"),
          _createElementVNode("p", null, "استراتژی مطالعه، آزمون‌های جدید و توصیه نمره — هفته‌ای یک‌بار، بدون اسپم.")
        ], -1)),
        _createElementVNode("form", {
          class: "newsletter-form",
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("input", {
            type: "email",
            placeholder: "you@example.com",
            "aria-label": "آدرس ایمیل"
          }, null, -1),
          _createElementVNode("button", {
            type: "submit",
            class: "btn-subscribe"
          }, [
            _createTextVNode(" عضویت "),
            _createElementVNode("i", { class: "bi bi-send-fill" })
          ], -1)
        ]))], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/dashboard",
            class: "footer-brand"
          }, {
            default: _withCtx(() => [
              _createVNode(BrandLogo, { size: "lg" })
            ]),
            _: 1
          }),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "footer-tagline" }, " آزمون‌های شبیه‌سازی آیلتس کامپیوتری واقع‌گرایانه و تمرین — برای رسیدن به نمره هدف با اطمینان. ", -1)),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socials, (s) => {
              return _createElementVNode("a", {
                key: s.label,
                href: s.url,
                "aria-label": s.label,
                class: "social"
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(s.icon)
                }, null, 2)
              ], 8, _hoisted_8)
            }), 64))
          ])
        ]),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
          return _createElementVNode("div", {
            class: "footer-col",
            key: col.title
          }, [
            _createElementVNode("h6", null, _toDisplayString(col.title), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.links, (link) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: link.text
                }, [
                  (link.to)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: link.to
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(link.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: link.url || '#'
                      }, _toDisplayString(link.text), 9, _hoisted_9))
                ]))
              }), 128))
            ])
          ])
        }), 64)),
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"footer-col\" data-v-9e9ca7a2><h6 data-v-9e9ca7a2>تماس</h6><ul class=\"contact-list\" data-v-9e9ca7a2><li data-v-9e9ca7a2><i class=\"bi bi-envelope\" data-v-9e9ca7a2></i> info@cocouni.com</li><li data-v-9e9ca7a2><i class=\"bi bi-telephone\" data-v-9e9ca7a2></i> +1 (000) 123-4567</li><li data-v-9e9ca7a2><i class=\"bi bi-geo-alt\" data-v-9e9ca7a2></i> در سراسر جهان، آنلاین</li></ul></div>", 1))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", null, "© " + _toDisplayString(_unref(year)) + " CocoUni. تمامی حقوق محفوظ است.", 1),
        _cache[5] || (_cache[5] = _createElementVNode("ul", { class: "legal" }, [
          _createElementVNode("li", null, [
            _createElementVNode("a", { href: "#" }, "حریم خصوصی")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", { href: "#" }, "شرایط استفاده")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", { href: "#" }, "کوکی‌ها")
          ])
        ], -1))
      ])
    ])
  ]))
}
}

})